import OperationsWindow from './OperationsWindow';

export default OperationsWindow;
